import apiClient from "./baseUrl/axiosConfig";

// Fetches the active site template configuration. When `enabled` is false the
// SPA renders the default design unchanged.
export const getSiteTheme = async () => {
  const response = await apiClient.get("/site/theme");
  return response.data;
};
